import { COMPOSITION_CATEGORIES_AND_SUBCATEGORIES_QUERY } from '@src/gql/category-gql';
import { COMPOSITION_TEMPLATES_QUERY } from '@src/gql/compositions-gql';

import type { Client } from '@datocms/cma-client-browser';
import type ApiClient from '@src/apiClient/ApiClient';
import type {
  RawCategory,
  RawComposition,
} from '@src/components/sidepanel/CompositionContext';
import type { GraphQLClient } from 'graphql-request';

export class CompositionRepository {
  private dClient: Client | ApiClient;
  private gqlClient: GraphQLClient;

  constructor(dClient: Client | ApiClient, gqlClient: GraphQLClient) {
    this.dClient = dClient;
    this.gqlClient = gqlClient;
  }

  async getCompositions() {
    const compositionsResponse = await this.gqlClient.request<{
      allCompositions: RawComposition[];
    }>(COMPOSITION_TEMPLATES_QUERY);

    return compositionsResponse.allCompositions;
  }

  async getCategoriesWithCompositions() {
    const categoriesResponse = await this.gqlClient.request<{
      allGraphicCategories: RawCategory[];
    }>(COMPOSITION_CATEGORIES_AND_SUBCATEGORIES_QUERY);

    return categoriesResponse.allGraphicCategories;
  }
}
